import React from 'react'
import { useParams } from 'react-router-dom'
import { useRedirectTo } from '@@partner:helpers/hooks/location'

import { Panel } from 'rsuite'
import CustomerForm from '@components/customers/CustomerForm'

import { ROUTE_CUSTOMERS } from '@@partner:config/routes'

export default function CustomerFormPage () {
  const { customerId, brandSlug } = useParams<any>()
  const redirectToCatalog = useRedirectTo(ROUTE_CUSTOMERS, {
    brandSlug
  })

  return (
    <div className="CustomerFormPage">
      <h1 className="u-heading">
        {customerId ? 'Редактирование' : 'Добавление'} пользователя
      </h1>
      <Panel shaded>
        <CustomerForm customerId={customerId} onSaved={redirectToCatalog} />
      </Panel>
    </div>
  )
}
